import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src", "alt"];
const _hoisted_2 = {
    key: 1,
    class: "flex h-full w-full items-center justify-center bg-gray-100 text-gray-600"
};
import { computed, ref, watch } from 'vue';
import CategoryIcon from '../CategoryIcon.vue';
import { useCategoryIconStyles } from '../../composables/useCategoryIconStyles';
import { resolveMenuItemCategoryIcon, resolveMenuItemCategoryColor } from '../../utils/resolveMenuItemCategoryIcon';
import { sanitizeProductImageUrl } from '../../utils/productImageUtils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartProductThumbnail',
    props: {
        menuItem: {},
        size: { default: 'md' }
    },
    setup(__props) {
        const props = __props;
        const { wrapperStyle: categoryIconWrapperStyle } = useCategoryIconStyles();
        const imageFailed = ref(false);
        const resolvedImageUrl = computed(() => sanitizeProductImageUrl(props.menuItem.imageUrl));
        const showImage = computed(() => Boolean(resolvedImageUrl.value) && !imageFailed.value);
        const alt = computed(() => props.menuItem.name);
        const categoryIcon = computed(() => resolveMenuItemCategoryIcon(props.menuItem));
        // Im Portal hinterlegte Kategorie-Farbe; Fallback auf neutrales Grau.
        const categoryColor = computed(() => resolveMenuItemCategoryColor(props.menuItem) || '#4b5563');
        const sizeClass = computed(() => (props.size === 'sm' ? 'h-12 w-12' : 'h-16 w-16'));
        const iconSize = computed(() => (props.size === 'sm' ? '1.75rem' : '2.25rem'));
        watch(() => props.menuItem.imageUrl, () => {
            imageFailed.value = false;
        });
        function onImageError() {
            imageFailed.value = true;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cart-product-thumbnail flex-shrink-0 overflow-hidden rounded-lg", sizeClass.value]),
                style: _normalizeStyle(_unref(categoryIconWrapperStyle))
            }, [
                (showImage.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: resolvedImageUrl.value,
                        alt: alt.value,
                        class: "h-full w-full object-cover",
                        onError: onImageError
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(CategoryIcon, {
                            icon: categoryIcon.value,
                            size: iconSize.value,
                            color: categoryColor.value,
                            inline: false,
                            decorative: ""
                        }, null, 8 /* PROPS */, ["icon", "size", "color"])
                    ]))
            ], 6 /* CLASS, STYLE */));
        };
    }
});
